$('.block-testimonial-slider').each(function() {

	const slider = $(this);

	let opts = {
		autoplay: {
			delay: 7000,
		},
        keyboard: {
            enabled: true,
        },
		loop: true,
		navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
        spaceBetween: 20,
		speed: 500,
	};

	const swiper = new Swiper($(this).find('.swiper')[0], opts);

});
